import React from "react";
import WomanLeader from "../../../assets/images/png/mba/mba-leader-woman-v1.png";
import ManLeader from "../../../assets/images/png/mba/mba-leader-man-v1.png";
import HijabLeader from "../../../assets/images/png/mba/mba-leader-hijab-v1.png";

const APPLY_URL = "https://utiva.co/mba/apply";

const MBACohortStrip = () => {
  return (
    <section
      className="bg-primary min-h-[126px] text-white border-b-4 border-secondary grid grid-cols-2 lg:grid-cols-mba-cohort items-center gap-4 lg:gap-6 px-4 sm:px-[18px] lg:px-[max(30px,50vw-630px)] py-[15px] sm:py-[18px]"
      aria-label="Next Global MBA cohort begins 3rd of September 2026"
    >
      <div
        className="bg-secondary w-[72px] h-[76px] sm:w-[86px] sm:h-[90px] text-primary rounded-2xl grid grid-cols-[1fr_auto] content-center gap-x-[5px] px-3 py-2.5 shadow-[0_14px_30px_#00000026]"
        aria-hidden="true"
      >
        <span className="tracking-[0.15em] col-span-2 text-sm font-black">
          SEP
        </span>
        <strong className="tracking-[-0.07em] text-[35px] sm:text-[42px] leading-[0.96]">
          03
        </strong>
        <b className="writing-mode-vertical self-center rotate-180 text-sm font-normal">
          2026
        </b>
      </div>

      <div className="min-w-0">
        <p className="text-secondary tracking-[0.1em] m-0 mb-1 text-sm font-black">
          NEXT GLOBAL MBA COHORT
        </p>
        <h2 className="text-white tracking-[-0.025em] m-0 text-[21px] sm:text-[clamp(23px,2.2vw,31px)] leading-[1.18] font-poppins font-bold">
          Starts Thursday, 3rd of September 2026
        </h2>
      </div>

      <div className="hidden md:flex items-center gap-3.5">
        <div className="flex-none pl-[11px] flex" aria-hidden="true">
          <img
            src={WomanLeader}
            alt=""
            className="border-[3px] border-primary bg-white object-cover object-top rounded-full w-[51px] h-[51px] -ml-[11px] block"
          />
          <img
            src={ManLeader}
            alt=""
            className="border-[3px] border-primary bg-white object-cover object-top rounded-full w-[51px] h-[51px] -ml-[11px] block"
          />
          <img
            src={HijabLeader}
            alt=""
            className="border-[3px] border-primary bg-white object-cover object-top rounded-full w-[51px] h-[51px] -ml-[11px] block"
          />
        </div>
        <p className="grid gap-0.5 m-0">
          <strong className="text-white text-base font-poppins font-semibold">
            Applications are open
          </strong>
          <span className="text-[#d7ddff] text-[15px] leading-[1.35]">
            Join ambitious professionals across the world.
          </span>
        </p>
      </div>

      <a
        href={APPLY_URL}
        className="min-h-[50px] col-span-2 lg:col-span-1 w-full lg:w-auto text-white whitespace-nowrap border border-white/30 rounded-[11px] justify-center items-center gap-2.5 px-[18px] py-[13px] text-[15px] font-poppins font-extrabold inline-flex transition-colors hover:bg-white hover:text-primary"
      >
        Secure your place <span aria-hidden="true">↗</span>
      </a>
    </section>
  );
};

export default MBACohortStrip;
